import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue";
const _hoisted_1 = { class: "filterPriceRange row" };
const _hoisted_2 = { class: "col-12" };
const _hoisted_3 = { class: "priceChart" };
const _hoisted_4 = { class: "col-12" };
const _hoisted_5 = { class: "col-6 pr-2" };
const _hoisted_6 = { class: "col-6 pl-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_v_range_slider = _resolveComponent("v-range-slider");
    const _component_v_text_field = _resolveComponent("v-text-field");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _cache[3] || (_cache[3] = _createElementVNode("div", { class: "col-12 border-top pt-4" }, [
            _createElementVNode("h3", { class: "font6-responsive strong mb-3 d-inline-block" }, "Preisspanne:")
        ], -1)),
        _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.priceBarsView, (bar, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: _normalizeClass(["balken", { active: bar.active }]),
                        key: index,
                        style: _normalizeStyle({ height: `${bar.height}px` })
                    }, null, 6));
                }), 128))
            ])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_v_range_slider, {
                "onUpdate:modelValue": [
                    _ctx.updateRange,
                    _cache[0] || (_cache[0] = ($event) => ((_ctx.slider) = $event))
                ],
                modelValue: _ctx.slider,
                step: 1,
                max: _ctx.sliderMaxValue,
                min: _ctx.sliderMinValue,
                color: "#b5b5b5",
                "thumb-color": "#888",
                "track-color": "#aaa"
            }, null, 8, ["onUpdate:modelValue", "modelValue", "max", "min"])
        ]),
        _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_v_text_field, {
                "onUpdate:modelValue": [
                    _ctx.updateMin,
                    _cache[1] || (_cache[1] = ($event) => ((_ctx.slider[0]) = $event))
                ],
                modelValue: _ctx.slider[0],
                type: "number",
                label: "Min. €",
                class: "[ minFieldCy ]"
            }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ]),
        _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_v_text_field, {
                "onUpdate:modelValue": [
                    _ctx.updateMax,
                    _cache[2] || (_cache[2] = ($event) => ((_ctx.slider[1]) = $event))
                ],
                modelValue: _ctx.slider[1],
                type: "number",
                label: "Max. €",
                class: "[ maxFieldCy ]"
            }, null, 8, ["onUpdate:modelValue", "modelValue"])
        ])
    ]));
}
